<template>
  <div class="page-list">
    <div class="error" v-if="error">
      <p> {{ error }} </p>
      <button @click="error = null">ЗАКРЫТЬ</button>
    </div>
    <div class="page-title">
      <div class="page-back" @click="$router.go(-1)">
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path fill="currentColor" d="M10.05 16.94V12.94H18.97L19 10.93H10.05V6.94L5.05 11.94Z"/>
        </svg>
      </div>
      Сказать СПАСИБО
    </div>
    <div class="page-subtitle" style="text-align: left;">
      <p style="opacity: .5"> Осталось в этом месяце: {{ count }} </p>
    </div>
    <EmployerComponent :employee="employee"/>
    <br><br>

    <!--div class="card" style="background: #0984e3; display: flex" @click="worth = 999">
        <div>
            <div class="card-title" style="color: #fff"> СПАСИБО </div>
            <div class="card-subtitle" style="color: #fff"> Подарить МОИ заработанные СПАСИБО в качестве исключительной благодарности </div>
        </div>
        <div style="display: flex; margin: 0 0 0 auto; align-items: center">
            <button class="gift-btn" @click="(worth = 999);self = self > 0 ? self - 1 : self"> - </button>
            <input style="width: 18px" class="gift-btn"  type="text" v-model="self" disabled />
            <button class="gift-btn" @click="(worth = 999); self = self === amount ? self : self + 1"> + </button>
            <button class="gift-btn" @click="(worth = 999); self = amount"> Все </button>
        </div>
    </div>
    <br><br-->

    <div class="page-subtitle" style="text-align: left">
      За что Вы отправляете СПАСИБО <br>
      Выберите категорию благодарности
    </div>

    <div v-for="it in values" :key="it.id" class="card" :class="{'worth-active': worth === it.id}"
         style="width: 100%; border-left: 5px solid black; border-right: 5px solid black"
         :style="{'border-left-color': it.color, 'border-right-color': it.color}" @click="worth = it.id">
      <div class="card-title">
        <span class="card-icon" v-html="it.icon"> </span><div> {{ it.name }}</div>
      </div>
      <div v-if="worth === it.id" class="card-subtitle"> {{ it.description }}</div>
      <ul v-if="worth === it.id">
        <li class="card-list" v-for="(it, index) in it.conditions" :key="index"> {{ it }} </li>
      </ul>
    </div>

    <div class="page-subtitle" style="text-align: left; margin: 32px 0 0 0 ">
      <b>Комментарий обязателен</b>
    </div>

    <textarea placeholder="Расскажите подробнее о достоинствах коллеги, ему будет приятно:)" v-model="comment"
              :disabled="(self === 0 && count === 0)" style="height: 180px; font-size: 17px"></textarea>
    <button @click.prevent="create" :disabled="isLoading || (self === 0 && count === 0)">
      {{ isLoading ? 'СПАСИБО отправляется...' : 'Отправить СПАСИБО' }}
    </button>
  </div>
</template>

<script>
import EmployerComponent from "@/components/EmployerComonent.vue";

export default {
  name: 'ProductPage',
  components: {EmployerComponent},
  metaInfo() {
    return {
      title: 'СПАСИБО',
      meta: [
        {name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0'}
      ]
    }
  },
  data: function () {
    return {
      self: 0,
      isLoading: false,
      comment: '',
      worth: 0,
      error: null
    }
  },
  computed: {
    employee() {
      return this.$store.getters.currentEmployee
    },
    amount() {
      return this.$store.getters.amount
    },
    to() {
      return this.$store.getters.to
    },
    orders() {
      return this.$store.getters.orders
    },
    profile() {
      return this.$store.getters.profile
    },
    thanks() {
      return this.$store.getters.from
    },
    count() {
      if (this.profile && [794286672, 11098895180, 15064562551].indexOf(this.profile.id) > -1) {
         return 999
       } else {
         return 3 - this.thanks.filter(it => it.worth !== 999 && new Date(it.date).getMonth() === new Date().getMonth() && new Date(it.date).getFullYear() === new Date().getFullYear()).length
       }
    },
    values() {
      return this.$store.getters.values
    }
  },
  methods: {
    create() {
      if (this.worth === 0) {
        this.error = 'Выберите ценность'
        return
      }
      if (this.comment.length === 0) {
        this.error = 'Оставьте комментарий'
        return
      }
      if (this.comment.length < 10) {
        this.error = 'Оставьте более подробный комментарий'
        return
      }
      this.isLoading = true
      if (this.worth === 999) {
          this.$store.dispatch('createThanksOwn', {
            from: this.profile.id,
            to: this.employee.id,
            comment: this.comment,
            worth: this.worth,
            count: this.self
          })
              .finally(() => {
                this.isLoading = false
                this.error = 'СПАСИБО отправлено'
                setTimeout(() => {
                  this.$router.push('/profile')
                }, 1250)
              })
      } else {
          this.$store.dispatch('createThanks', {
            from: this.profile.id,
            to: this.employee.id,
            comment: this.comment,
            worth: this.worth
          })
              .finally(() => {
                this.isLoading = false
                this.error = 'СПАСИБО отправлено'
                setTimeout(() => {
                  this.$router.push('/profile')
                }, 1250)
              })
      }
    },
    getWorthColor(worth) {
      if (worth === 1) return 'red'
      if (worth === 2) return 'orange'
      if (worth === 3) return 'blue'
      if (worth === 4) return 'red'
      if (worth === 5) return 'purple'
      if (worth === 6) return 'yellow'
    },
    showHint(worth) {
      if (worth === 1) alert('Наши действия ориентированы на результат, оптимизацию процессов и поиск новых путей совершенствования сервиса и работы. Мы действуем по собственной инициативе, осознавая ответственность за успех своей компании.\n\n' +
          'За эффективные идеи\n' +
          'За способность достигать высоких результатов\n' +
          'За проктивный подход в работе, инициативу и самостоятельность в решении сложных вопросов\n'
      )
      if (worth === 2) alert('Мы с заботой, теплотой и вниманием относимся к пациентам и коллегам. Всегда готовы помочь. В интересах здоровья. Действуем, превосходя ожидания.\n\n' +
          'За сервисную историю "превосходя ожидание" (в т.ч. благодарности от пациентов)\n' +
          'За внимательное отношение к коллегам и пациентам, искреннее желание помочь\n' +
          'За отзывчивость и взаимопомощь (внеплановый выход на другой филиал и др.)\n'
      )
      if (worth === 3) alert('Мы с ответственностью относимся к своей деятельности, принимая во внимание интересы сотрудников и пациентов.\n\n' +
          'За надежность, обязательность в выполнении задач\n' +
          'За желание и умение брать на себя ответственность за блок работы\n'
      )
      if (worth === 4) alert('Мы занимаемся любимым делом, это безумный драйв 24/7. Мы активно и безвозмездно делимся своим креативом, принимаем участие в жизни Садко, в мероприятиях и проектах компании.\n\n' +
          'За помощь в экстремальных ситуациях (неотложные состояния, аварийные ситуации)\n' +
          'За помощь в закрытии вакансий "Приведи друга"\n' +
          'За отзыв о враче, клинике от сотрудника на внешних ресурсах\n' +
          'За участие в мероприятиях компании и помощь в организации\n'
      )
      if (worth === 5) alert('Мы рассатриваем коммуникации как открытое и честное обсуждение. Нам важно, чтобы наши сотрудники чувствовали себя в безопасности, открыто обсуждали идеи по улучшению и активно учавствовали в процессе принятия решений.\n\n' +
          'За свободное общение вне иерархических рамок\n' +
          'За честный обмен мнениями, за возможность посоветоваться, когда что-то идет не по плану\n'
      )
      if (worth === 6) alert('Садко - это команда профессионалов-единомышленников, постоянно стремящихся к развитию. Мы стремимся вперед и с каждым годом набираем высоту.\n\n' +
          'За наставничество (эффективное обучение новичков)\n' +
          'За саморазвитие сотрудника и повышение своей квалификации\n' +
          'За выступление, доклад на любом мероприятии\n'
      )
    }
  }
}
</script>

<style scoped>
.error {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 56px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  z-index: 1000;
}
.card-title {
  width: 100%;
  display: flex;
  align-items: center;
  align-content: space-between;
}

.card-title svg {
  margin-left: auto;
  margin-right: 0;
  width: 22px;
  height: 22px;
  color: #404344;
}

textarea {
  margin: 16px;
  padding: 12px 16px;
  border: none;
  border-radius: 8px;
  width: calc(100% - 64px);
}

button {
  margin: 16px;
  padding: 12px 16px;
  border: none;
  border-radius: 8px;
  width: calc(100% - 32px);
  background: #42b983;
  color: white;
}

.worths {
  display: flex;
  align-items: center;
  justify-content: center;
}

.worth {
  border: 5px solid red;
  padding: 1em;
  border-radius: 1em;
  margin: 1em 1em 0;
}

.worth h4 {
  padding-bottom: 1em;
}

.worth p {
  font-size: 0.8125em;
}

.worth-active {
  background: lightgreen;
}

.gift-btn {
    background: #f1f1f1;
    border: none;
    border-radius: 9px;
    height: 32px;
    line-height: 32px;
    padding: 0 12px;
    margin: 0 0 0 12px;
    color: #404344;
    font-size: 15px;
}
</style>
